import { Routes } from '@angular/router';

/**
 * Application routes. Both paths lazy-load the same account-deletion feature;
 * the empty path is used when no token is present (error state in the component).
 */
export const routes: Routes = [
  {
    /** Email link format: `/account-deletion/{token}?lang=pl` */
    path: 'account-deletion/:token',
    loadComponent: () =>
      import(
        './account-deletion/account-deletion/account-deletion.component'
      ).then((m) => m.AccountDeletionComponent),
  },
  {
    /** Fallback when opened without a token segment. */
    path: '',
    loadComponent: () =>
      import(
        './account-deletion/account-deletion/account-deletion.component'
      ).then((m) => m.AccountDeletionComponent),
  },
];
